'use client';

import React, { createContext, useContext } from 'react';

export type BackgroundColor = 'Default' | 'Transparent';

interface BackgroundColorContextType {
  backgroundColor: BackgroundColor;
}

const BackgroundColorContext = createContext<BackgroundColorContextType>({
  backgroundColor: 'Default',
});

export const useBackgroundColor = () => useContext(BackgroundColorContext);

interface BackgroundColorProviderProps {
  children: React.ReactNode;
  backgroundColor: BackgroundColor;
}

export const BackgroundColorProvider: React.FC<BackgroundColorProviderProps> = ({
  children,
  backgroundColor,
}) => {
  return (
    <BackgroundColorContext.Provider value={{ backgroundColor }}>
      {children}
    </BackgroundColorContext.Provider>
  );
};
